/*
 * Global focus-trap utility. Confines Tab / Shift+Tab focus within a container
 * while a modal surface (zoom gallery, future overlays) is open. Loaded ONCE in
 * layout/theme.liquid — never per-section (invariant 8). Consumers must guard
 * with `typeof createFocusTrap === 'function'` before calling.
 *
 *   var trap = createFocusTrap(panelElement);
 *   trap.activate();    // on open  — pair with removeAttribute('aria-hidden') + removeAttribute('inert')
 *   trap.deactivate();  // on close — pair with setAttribute('aria-hidden','true') + setAttribute('inert','')
 *
 * Only currently-visible focusables are considered, recomputed on every Tab so
 * the trap stays correct as content shows/hides inside the container.
 */
(function () {
  if (window.createFocusTrap) return;

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  window.createFocusTrap = function (container) {
    function focusable() {
      return Array.prototype.filter.call(
        container.querySelectorAll(FOCUSABLE),
        function (el) { return el.offsetParent !== null; }
      );
    }

    function onKeydown(event) {
      if (event.key !== 'Tab') return;
      var items = focusable();
      if (!items.length) return;

      var first = items[0];
      var last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      } else if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    }

    return {
      activate: function () { document.addEventListener('keydown', onKeydown); },
      deactivate: function () { document.removeEventListener('keydown', onKeydown); }
    };
  };
})();
